export const LOCAL_STORAGE = {
  IS_IMPERSONATE_ACCESS: 'is_impersonate_access',
  CUSTOMER_API_TOKEN: 'customer_api_token',
  COMPANY_INFO: 'company_info',
  FEEDBACK_HAS_BEEN_DISPLAYED: 'feedback_has_been_displayed',
  LOGO: 'logo',
  DISPOSITIVOS: 'contlabs_dispositivos',
};
